{
  "version": 1,
  "asset_id": "223eaaea-6e81-4361-840d-58c7f4b49f60",
  "project_id": "115256dd-a6cc-4bc1-95c1-d787d4c0e481",
  "url": "/__l5e/assets-v1/223eaaea-6e81-4361-840d-58c7f4b49f60/tiedowns-card.webp",
  "r2_key": "a/v1/115256dd-a6cc-4bc1-95c1-d787d4c0e481/223eaaea-6e81-4361-840d-58c7f4b49f60/tiedowns-card.webp",
  "original_filename": "tiedowns-card.webp",
  "size": 12522,
  "content_type": "image/webp",
  "created_at": "2026-07-28T02:25:38Z"
}
